import React from "react";

import Link from "core/Link";
import { LinkContainer } from "../styles";

import InfiniteScrolling from "../infinite-scrolling";
import FetchInactiveUploads from "./fetch-inactive-uploads";
import InactiveUpload from "./inactive-upload";
import Modal from "../../../containers/modal";

const InfinitePendingUploads = ({ uploads, loadMoreUploads }) => {
    const linkProps = {
        size: "md",
        styleType: "primary"
    };

    return (
        <section
            id="pending"
            className="infinite-page user-icons container row"
        >
            <div className="container moderator-letter-container">
                <div className="moderator-letter">
                    <h1>Thanks for Contributing!</h1>
                    <p>
                        Our Curation Team personally reviews every submission.
                        You can help us expedite processing by making sure icon
                        titles and tags are in English, relevant, and spelled
                        correctly. You can also help expedite processing by
                        adhering to our guidelines which can be{" "}
                        <Link
                            href="/handbook/create/#technical_guidelines"
                            target="_blank"
                            size="md"
                            styleType="primary"
                        >
                            found here.
                        </Link>
                    </p>
                    <p>We appreciate your patience!</p>
                    <p>– Your Curation Team</p>
                </div>
            </div>

            <header className="display-flex col-xs-12">
                <h3 className="ui_upload">Awaiting moderation</h3>
                <LinkContainer>
                    <Link href="/dashboard" {...linkProps}>
                        Dashboard
                    </Link>
                </LinkContainer>
            </header>

            <ul id="pending-uploads" className="col-xs-12 dashboard-user">
                {uploads.length ? (
                    <InfiniteScrolling
                        loadMore={loadMoreUploads}
                        elements={
                            uploads &&
                            uploads.map(upload => (
                                <InactiveUpload
                                    key={upload.id}
                                    upload={upload}
                                />
                            ))
                        }
                    />
                ) : (
                    <h2>There aren't any uploads to show</h2>
                )}
            </ul>
        </section>
    );
};

export default function InfinitePendingUploadsWrapper() {
    return (
        <div>
            <FetchInactiveUploads limit={20} offset={0} uploadState="pending">
                <InfinitePendingUploads />
            </FetchInactiveUploads>
            <Modal />
        </div>
    );
}
